<div class="wrapper">
    <div class="input-wrapper">
        <label for="partnerId">Partner ID : </label>
        <input id="partnerId" [value]="partner.partnerId" type="text" pInputText disabled>
        <label for="partnerName">Partner Name : </label>
        <input id="partnerName" [value]="partner.partnerName" type="text" pInputText disabled>
    </div>
    <div class="input-wrapper">
        <label for="serviceOfferingName">Service Offering Name : </label>
        <p-autoComplete 
            id="serviceOfferingName"
            [(ngModel)]="serviceLevelName"
            [suggestions]="serviceLevelOptions"
            (completeMethod)="getServiceLevelOptions()"
            [disabled]="true" ></p-autoComplete>
        <label for="accessCode">Access Code : </label>
        <p-dropdown 
            id="accessCode" 
            [options]="accessCodes"
            [autoDisplayFirst]="false"
            optionLabel="name"
            [disabled]="true"
            [(ngModel)]="selectedAccessCode">
        </p-dropdown>
    </div>
    <div class="tables-wrapper">
        <table class="selection-table">
            <caption class="required-field">Allowable Market Sector : </caption>
            <tr>
                <th>Market Sector</th>
                <th>Geogating Mode</th>
                <th>Product Code</th>
                <th>Geogating Type</th>
            </tr>
            <tr *ngFor="let option of marketSectors">
                <td>
                    <span class="option-name">{{option.name}}</span>
                    <p-checkbox
                        [value]="option.id" 
                        [(ngModel)]="selectedMarketSectorIds"
                        (ngModelChange)="onSelectedMarketSectorIdsChanged()"></p-checkbox>
                </td>
                <td>
                    <p-dropdown
                        class="table-input"
                        [(ngModel)]="marketSectorProductCodeMap[option.id].geogatingMode"
                        (onChange)="onGeogatingModeBlurred(option.id)"
                        [options]="geogatingModeOptions"
                        [disabled]="selectedMarketSectorIds.indexOf(option.id) === -1" ></p-dropdown>
                </td>
                <td>
                    <p-inputMask
                        mask="9999-99-9"
                        class="table-input"
                        [(ngModel)]="marketSectorProductCodeMap[option.id].productCode"
                        (onComplete)="onProductCodeBlurred(option.id)"
                        [disabled]="selectedMarketSectorIds.indexOf(option.id) === -1" ></p-inputMask>
                </td>
                <td>
                    <p-dropdown 
                        class="table-input"
                        [(ngModel)]="marketSectorProductCodeMap[option.id].geogatingType"
                        (onChange)="onGeogatingTypeBlurred(option.id)"
                        [options]="geogatingTypeOptions"
                        [disabled]="selectedMarketSectorIds.indexOf(option.id) === -1" ></p-dropdown>
                </td>
            </tr>
        </table>
        <table class="selection-table">
            <caption class="required-field">Allowable Durations : </caption>
            <tr *ngFor="let option of durations">
                <td>
                    <span class="option-name">{{option.name}} {{option.value}}</span>
                    <p-checkbox
                        [value]="option.id" 
                        [(ngModel)]="selectedDurationIds"
                        (ngModelChange)="onSelectedDurationIdsChanged()"></p-checkbox>
                </td>
            </tr>
        </table>
        <table class="selection-table">
            <caption class="required-field">Allowable Coverage Levels :</caption>
            <tr *ngFor="let option of coverageLevels">
                <td>
                    <span class="option-name">{{option.name}}</span>
                    <p-checkbox
                        [value]="option.id" 
                        [(ngModel)]="selectedCoverageLevelIds"
                        (ngModelChange)="onSelectedCoverageLevelIdsChanged()"></p-checkbox>
                </td>
            </tr>
        </table>
    </div>
    <div class="button-wrapper">
        <button
            pButton
            label="Cancel"
            (click)="onCancelClicked()"
            class="p-button-danger"
        ></button>
        <button
            pButton
            label="Save"
            [disabled]="disableButton || intialLoadDisable || disableFields"
            (click)="onSaveClicked()"
        ></button>
    </div>
</div>